import { useContext, useState } from "react";
import {
  Box,
  Grid,
  IconButton,
  Menu,
  MenuItem,
  Tooltip,
} from "@material-ui/core";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import VisibilityIcon from "@mui/icons-material/Visibility";
import CheckCircle from "@mui/icons-material/CheckCircle";
import { CheckCircleOutline } from "@mui/icons-material";
import CheckPermission from "../../../../helpers/Administradores/Permissions";
import { openModalConfirmFinishCourse } from "../../../../context/FormacionDesarollo/TrainingActions";
import TrainingContext from "../../../../context/FormacionDesarollo/TrainingContext";
import ModalConfirmFinishCourse from "../modals/ModalConfirmFinishCourse";
const MenuList = (props: any, evaluar: any) => {
  const [seeDetails, setSeeDetails] = useState<any>(null);
  const open = Boolean(seeDetails);
  const { dispatch } = useContext(TrainingContext);
  const type = props.type;
  const seeInformation = () => {
    console.log("Ver Información");
  };
  const terminarCurso = (id: any, idCTP: any, bussinesName: any) => {
    console.log("Terminar curso para el usuario: ", props);
    console.log(id);
    if (type === "curso") {
      console.log("lo que se va a terminar es un curso");
      openModalConfirmFinishCourse(id, idCTP, bussinesName, true, dispatch);
    } else if (type === "trainingPlan") {
      console.log("lo que se va a terminar es un plan de capacitacion");
    }
  };
  const reactivarCurso = () => {
    console.log("Reactivar curso para el usuario: ", props);
  };
  return (
    <>
      <Tooltip title="Opciones" placement="right">
        <Box className="IconButtonPoints" mr={2}>
          <IconButton onClick={(e) => setSeeDetails(e.currentTarget)}>
            <MoreVertIcon style={{ color: "#fabb00" }} />
          </IconButton>
        </Box>
      </Tooltip>
      <Menu
        className="MoreVerIcon"
        anchorEl={seeDetails}
        open={open}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        onClose={() => setSeeDetails(null)}
      >
        {CheckPermission("FormacionDesarrollo.Cursos.Ver") && (
          <MenuItem
            button
            onClick={seeInformation}
            style={{ justifyContent: "space-between" }}
          >
            <div className="contenedorTextoMenuCourse">
              <span className="textoMenuEditarCourse">Ver</span>
            </div>
            <div>
              <VisibilityIcon className="iconoMenuViewCourse" />
            </div>
          </MenuItem>
        )}
        {props.terminatedCourses == 1 ? (
          <>
            <MenuItem
              button
              onClick={reactivarCurso}
              style={{ justifyContent: "space-between" }}
            >
              <div className="contenedorTextoMenuCourse">
                <span className="textoMenuEditarCourse">Reactivar</span>
              </div>
              <div>
                <CheckCircle className="iconoMenuViewCourse" />
              </div>
            </MenuItem>
          </>
        ) : (
          <>
            <MenuItem
              button
              onClick={() =>
                terminarCurso(props.id, props.idCTP, props.bussinesName)
              }
              style={{ justifyContent: "space-between" }}
            >
              <div className="contenedorTextoMenuCourse">
                <span className="textoMenuEditarCourse">Terminar</span>
              </div>
              <div>
                <CheckCircleOutline className="iconoMenuViewCourse" />
              </div>
            </MenuItem>
          </>
        )}
      </Menu>
    </>
  );
};
export default MenuList;
